export { default } from './GlobalLayout';
